import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Building2, CheckCircle } from 'lucide-react';

export const ConfirmProposalDialog = ({ open, onOpenChange, proposal, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Confirm Proposal</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <p className="text-sm">
          Are you sure you want to confirm this proposal? This indicates that the client has accepted the proposal.
        </p>
        {proposal && (
          <div className="p-4 bg-muted rounded-lg">
            <p className="font-semibold">{proposal.title}</p>
            <p className="text-sm text-muted-foreground">{proposal.client_name}</p>
            {proposal.company_name && (
              <p className="text-sm text-muted-foreground flex items-center gap-1">
                <Building2 className="h-3 w-3" />{proposal.company_name}
              </p>
            )}
            {proposal.amount && (
              <p className="text-lg font-mono mt-2">INR {proposal.amount.toLocaleString('en-IN')}</p>
            )}
          </div>
        )}
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onConfirm} className="bg-green-600 hover:bg-green-700">
            <CheckCircle className="mr-2 h-4 w-4" />
            Confirm Proposal
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
